import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { useEffect, useState } from 'react';
import { apiService } from '../../api/axiosClient';

const monthLabels = [
  "1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월", "합계"
];

const StatType = ({year}) => {
    const [online, setOnline] = useState([]);
    const [offline, setOffline] = useState([]);

    useEffect(() => {
        const fetchData = async (btype) => {
            try {
                const response = await apiService.get(`/stat/type/${year}/${btype}`);
                const payload = response.data.list;
                if (btype == "online") {
                    setOnline(payload);
                } else {
                    setOffline(payload);
                }
            } catch (error) {
                console.error(`Error fetching ${btype} stat data:`, error);
            }
        }

        fetchData("online");
        fetchData("offline");
    }, [year]);

    return (
        <TableContainer component={Paper}>
            <Typography variant="h6" sx={{ p: 2 }}>
                유형별 통계
            </Typography>
            <Table>
                <TableHead>
                    <TableRow sx={{ backgroundColor: "#60718b" }}>
                        <TableCell align="center" sx={{ color: "#fff", width: 100 }}><strong>유형</strong></TableCell>
                        <TableCell align="center" sx={{ color: "#fff", width: 100 }}><strong>구분</strong></TableCell>
                        {monthLabels.map((label, index) => (
                            <TableCell key={index} align="right" sx={{ color: "#fff", width: 140 }}><strong>{label}</strong></TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableCell align="center" rowSpan={5}>온라인</TableCell>
                    {online.map((row, idx) => (
                        <TableRow 
                            key={idx}
                            sx={{
                                backgroundColor: idx % 2 === 0 ? "#ffffff" : "#eff3f9"
                            }
                        }>
                        
                        <TableCell align="center">{row.gubun}</TableCell>
                        {monthLabels.map((month, mIdx) => (
                            <TableCell key={mIdx} align="right">
                                {Number(row[month]).toLocaleString()}원
                            </TableCell>
                        ))}
                        </TableRow>
                    ))}

                    <TableCell align="center" rowSpan={5}>오프라인</TableCell>
                    {offline.map((row, idx) => (
                        <TableRow 
                            key={idx}
                            sx={{
                                backgroundColor: idx % 2 === 0 ? "#ffffff" : "#eff3f9"
                            }
                        }>
                        
                        <TableCell align="center">{row.gubun}</TableCell>
                        {monthLabels.map((month, mIdx) => (
                            <TableCell key={mIdx} align="right">
                                {Number(row[month]).toLocaleString()}원
                            </TableCell>
                        ))}
                        </TableRow>
                    ))}

                    <TableRow>
                        <TableCell align="center" colSpan={2} sx={{ fontWeight: 'bold' }}>
                            <strong>총합</strong>
                        </TableCell>
                        {monthLabels.map((label, index) => {
                            const onlineTotal = online
                                .filter(row => row.gubun === "총합")
                                .reduce((acc, row) => acc + Number(row[label] || 0), 0);
                            const offlineTotal = offline
                                .filter(row => row.gubun === "총합")
                                .reduce((acc, row) => acc + Number(row[label] || 0), 0);
                            const total = onlineTotal + offlineTotal;

                            return (
                                <TableCell key={index} align="right" sx={{ fontWeight: 'bold' }}>
                                    <strong>{total.toLocaleString()}원</strong>
                                </TableCell>
                            );
                        })}
                    </TableRow>

                </TableBody>
            </Table>
        </TableContainer>
    );
    
};


export default StatType;